import { useState } from 'react';

import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';

import { useStudentSearchDropdown } from '../../../hooks/useStudentSearchDropdown';

export interface LookupAutocompleteProps {
  /** ID selecionado como string; `''` quando nada está selecionado. */
  readonly value: string;
  /** Rótulo da seleção corrente, exibido no campo. */
  readonly selectedLabel: string;
  /** Notifica o novo ID e rótulo (`''`/`''` ao limpar). */
  readonly onChange: (id: string, label: string) => void;
  readonly label: string;
  readonly placeholder: string;
}

export interface StudentAutocompleteProps extends LookupAutocompleteProps {
  /**
   * Texto digitado no campo sem seleção no lookup — alimenta o filtro por nome.
   * Disparado a cada tecla, com `''` quando o campo é esvaziado.
   */
  readonly onFreeTextChange: (term: string) => void;
}

/**
 * Autocomplete de aluno (lookup `person/shared/people-multiple`).
 *
 * Diferente dos outros dois lookups, aceita busca sem seleção: como o valor
 * pesquisável é o próprio nome, o texto digitado é repassado por
 * `onFreeTextChange` e vira filtro mesmo que o operador não escolha um item da
 * lista.
 */
export function StudentAutocomplete({
  value,
  selectedLabel,
  onChange,
  onFreeTextChange,
  label,
  placeholder,
}: StudentAutocompleteProps) {
  const [search, setSearch] = useState('');
  const { options, isQuerySuccess } = useStudentSearchDropdown(search);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value}
      selectedLabel={selectedLabel}
      options={options}
      isQuerySuccess={isQuerySuccess}
      search={search}
      onSearchChange={term => {
        setSearch(term);
        onFreeTextChange(term);
      }}
      onSelect={(id, itemLabel) => {
        onChange(id, itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange('', '');
        setSearch('');
      }}
    />
  );
}
